var BlockView = require('views/block/base-block-view');
var LocaleService = require('services/locale-service');
const AhoyService = require('services/ahoy-service');

var LinkView = BlockView.extend({
  className: 'links',
  initialize: function (options) {
    var self = this;
    this.autoComplete = true;
    this.completed = false;
    BlockView.prototype.initialize.apply(this, arguments);
    _.each(this.model.get('links'), function (link, i) {
      if (link.type === 'script') {
        link.attributes = self.createSafeString('data-execute=', link.exec);
      } else if (link.type === 'navigate') {
        link.attributes = self.createSafeString('data-navigate=', link.direction);
      } else if (link.type === 'close') {
        link.attributes = new Handlebars.SafeString('data-close=true');
      } else if (link.type === 'open_modal') {
        link.attributes = self.createSafeString('data-toggle=modal data-target=#', link.modal_id);
      } else if (link.type === 'complete') {
        link.attributes = new Handlebars.SafeString('data-navigate=complete');
      } else if (link.type === 'close_content') {
        const attributes = ['data-close-content=true'];
        if (link.safe) {
          attributes.push('data-safe-exit=true');
          link.path = new Handlebars.SafeString(link.path);
        }
        link.attributes = new Handlebars.SafeString(attributes.join(' '));
      } else if (link.type === 'completeme') {
        if (typeof link.modal_id !== 'undefined') {
          link.attributes = self.createSafeString(
            'data-navigate=completeme data-toggle=modal data-target=#',
            link.modal_id
          );
          self.autoComplete = false;
        } else {
          link.attributes = new Handlebars.SafeString('data-navigate=completeme');
        }
      } else if (link.type === 'scroll') {
        link.attributes = new Handlebars.SafeString(`data-scroll-to="${Handlebars.Utils.escapeExpression(
          link.scroll_to
        )}"
         data-scroll-pane="${link.scroll_pane ? Handlebars.Utils.escapeExpression(link.scroll_pane) : 'html, body'}"
         data-offset-top="${link.offset_top ? Handlebars.Utils.escapeExpression(link.offset_top) : 0}"`);
      }

      if (link.type === 'new_window') {
        link.attributes = new Handlebars.SafeString(
          `target=_blank aria-label="${LocaleService.t('link.newWindowWarning')}"`
        );
      } else if (link.path && !(link.path instanceof Handlebars.SafeString) && link.path.substring(0, 1) !== '#') {
        link.path = self.createSafeString('#', LocaleService.t(link.path));
      }
    });
  },
  createSafeString: function (safeString, unsafeString) {
    return new Handlebars.SafeString(safeString + Handlebars.Utils.escapeExpression(unsafeString));
  },
  load: function () {
    var self = this;

    // render aria properties in load method to make sure we can assign values
    _.each(this.model.get('links'), function (link, i) {
      self.renderChildAriaProperties(link, i);
    });
    //TODO: can we assume all links are added via this view?
    this.delegate('click', 'a', function (e) {
      $(e.currentTarget).addClass('clicked');
    });
    this.delegate('click', '[data-close-content]', function (e) {
      e.preventDefault();
      if ($(e.currentTarget).data().safeExit) {
        window.postMessage(
          {
            event_type: 'safety-exit',
            redirectUrl: $(e.currentTarget).attr('href'),
          },
          window.location.origin
        );
      } else {
        window.postMessage({ event_type: 'close-content' }, window.location.origin);
      }
    });
    this.delegate('click', '[data-navigate]', function (e) {
      e.preventDefault();
      var navigateType = $(e.currentTarget).attr('data-navigate');
      AhoyService.track('link', { action: 'navigate', target: navigateType });
      if (navigateType === 'complete') {
        Chaplin.mediator.publish('page:complete', { direction: 'forward' });
      } else if (navigateType === 'completeme') {
        if (!this.completed) {
          this.completed = true;
          this.readyToGo();
        }
      } else {
        Chaplin.mediator.publish('page:navigate', navigateType);
      }
    });
    this.delegate('click', '[data-execute]', function (e) {
      e.preventDefault();
      AhoyService.track('link', { action: 'execute', target: $(e.currentTarget).data('execute') });
      self.script[$(e.currentTarget).data('execute')]();
    });
    this.delegate('click', '[data-toggle]', function (e) {
      AhoyService.track('link', { action: 'toggle', target: $(e.currentTarget).data('target') });
    });
    this.delegate('click', '[data-scroll-to]', function (e) {
      e.preventDefault();

      const $currentTarget = $(e.currentTarget);
      const $scrollPane = $($currentTarget.data('scroll-pane'));
      const $scrollTarget = $($currentTarget.data('scroll-to'));
      const offsetTop = $currentTarget.data('offset-top');

      const scrollPaneBoundingClientRectTop = 0;
      const scrollPaneScrollTop = $scrollPane.scrollTop();
      const scrollTargetBoundingClientRectTop = $scrollTarget.get(0).getBoundingClientRect().top;

      $scrollPane.animate(
        {
          scrollTop:
            scrollTargetBoundingClientRectTop - scrollPaneBoundingClientRectTop + scrollPaneScrollTop + offsetTop,
        },
        500
      );

      AhoyService.track('link', { action: 'scroll', target: $(e.currentTarget).data('scroll-to') });
    });
  },
  play: function () {
    if (this.autoComplete) {
      this.completed = true;
      this.readyToGo();
    }
  },
});

module.exports = LinkView;
